/**
 * Dependencies.
 */
import applicationConstant from '@/modules/main/constants/application.constant';
import { BaseService } from '@/modules/main/services/base.service';

import DocumentModel from './document.model';

/**
 * Service `DocumentService`.
 */
class DocumentService extends BaseService<DocumentModel> {
  /**
   * Constructor.
   */
  constructor() {
    super(
      DocumentModel,
      DocumentModel.name,
      applicationConstant.apiDriverDCPrivateUrl
    );
  }

  getByType(
    code: string,
    type: 'DELIVERY' | 'DELIVERY_PACKAGE'
  ): Promise<DocumentModel[]> {
    const endpoint = `${this.getModelEndpoint}/${code}?type=${type}`;

    return this.GET(endpoint);
  }
}

/**
 * Export `documentService`.
 */
export const documentService = new DocumentService();
